import Vue from 'vue'
import Vuex from 'vuex'
import { mutations, actions, getters } from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'en',
    config: {},
    languages: ['en'],
    customer_id: ""
  },
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js